/* eslint-disable prefer-destructuring */
import { Component } from "react";
import DraftOffsetKey from "draft-js/lib/DraftOffsetKey";
import PropTypes from "prop-types";
import { isSelectedBlockEmpty } from "./utils";

export default class VerticalBlockCoordinates extends Component {
  static propTypes = {
    editorKey: PropTypes.string.isRequired,
    editorState: PropTypes.object.isRequired,
    children: PropTypes.func.isRequired,
  };

  state = {
    top: -9999,
    visible: false,
  };

  componentWillReceiveProps({ editorKey, editorState }) {
    setTimeout(() => {
      this.calculateCoordinatesAndSetState(editorKey, editorState);
    });
  }

  // @link https://github.com/facebook/draft-js/issues/45#issuecomment-190269630
  calculateCoordinatesAndSetState = (editorKey, editorState) => {
    const currentContent = editorState.getCurrentContent();
    const currentSelection = editorState.getSelection();

    if (currentSelection.isCollapsed() === false) {
      this.setState({
        top: -9999,
        visible: false,
      });

      return;
    }

    const currentBlock = currentContent.getBlockForKey(currentSelection.getStartKey());
    const offsetKey = DraftOffsetKey.encode(currentBlock.getKey(), 0, 0);
    const blockNode = document.querySelector(`[data-offset-key="${offsetKey}"]`);
    const editorNode = document.querySelector(`[data-editor="${editorKey}"]`);

    if (blockNode === null || editorNode === null) {
      return;
    }

    const clientTop = document.documentElement.clientTop;
    const containerTop = editorNode.getBoundingClientRect().top - clientTop;
    const calculatedTop = blockNode.getBoundingClientRect().top - containerTop;
    const visible = isSelectedBlockEmpty(editorState);

    if (this.state.top !== calculatedTop || this.state.visible !== visible) {
      this.setState({
        top: calculatedTop,
        visible: visible,
      });
    }
  };

  render() {
    const { children } = this.props;
    const { top, left, visible } = this.state;

    return children({
      top,
      left,
      visible,
    });
  }
}
